"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode, RefObject } from "react";
import { useEffect, useState } from "react";
import { createBreakpoint } from "react-use";
import SeasonsGridDropdownDesktopWrapper from "./SeasonsGridDropdownDesktopWrapper";
import SeasonsGridDropdownMobileWrapper from "./SeasonsGridDropdownMobileWrapper";
const useBreakpoint = createBreakpoint({
  LG: 1024,
  S: 0
});
export default function SeasonsGridDropdownItemsWrapper(t0) {
  const $ = _c(13);
  const {
    isOpen,
    filterLabel,
    buttonRef,
    setOpen,
    children
  } = t0;
  const breakpoint = useBreakpoint();
  let t1;
  if ($[0] !== breakpoint) {
    t1 = () => breakpoint !== "LG";
    $[0] = breakpoint;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getIsMobile = t1;
  const [isMobile, setIsMobile] = useState(false);
  let t2;
  if ($[2] !== getIsMobile) {
    t2 = () => {
      setIsMobile(getIsMobile());
    };
    $[2] = getIsMobile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== breakpoint) {
    t3 = [breakpoint];
    $[4] = breakpoint;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== buttonRef || $[7] !== children || $[8] !== filterLabel || $[9] !== isMobile || $[10] !== isOpen || $[11] !== setOpen) {
    t4 = <>{isMobile ? <SeasonsGridDropdownMobileWrapper isOpen={isOpen} label={filterLabel} setOpen={setOpen}>{children}</SeasonsGridDropdownMobileWrapper> : <SeasonsGridDropdownDesktopWrapper isOpen={isOpen} setOpen={setOpen} buttonRef={buttonRef}>{children}</SeasonsGridDropdownDesktopWrapper>}</>;
    $[6] = buttonRef;
    $[7] = children;
    $[8] = filterLabel;
    $[9] = isMobile;
    $[10] = isOpen;
    $[11] = setOpen;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}